import { KeyAsValue } from './types';

export default function keysToValues<T extends Record<string, any>>(source: T): KeyAsValue<typeof source> {
  return (Object.keys(source) as Array<keyof T>).reduce((acc, current) => {
    acc[current] = current;
    return acc;
  }, {} as KeyAsValue<typeof source>);
}
